<template>
  <section class="container list-style05-wrap mt-18">
    <ul class="row list-style05">
      <li class="col-6 col-sm-4" v-for="item in products" :key="item.productsId">
        <a href="" @click.prevent="moveToDetailPage(item.productsId)">
          <div class="list-style05--img mb-2">
            <img :src="item.productsMainImageUrl" alt="">
          </div>
          <h3 class="list-style05--tit white-space--pre">{{item.productsPageKoreanName}}</h3>
          <p class="list-style05--desc  white-space--pre">{{item.productsPageEnglishName}}</p>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import productApi from '@/apis/product';

export default {
  name: 'List',
  data() {
    return {
      products: [],
    };
  },
  async created() {
    this.products = await productApi.getProducts();
  },
  methods: {
    moveToDetailPage(productId) {
      this.$router.push({ name: 'ProductDetail', params: { productId } });
    },
  },
};
</script>

<style lang='scss' scoped>
.list-style-srch{
  &--total{
    text-align: center;
    background: url(~@/assets/images/common/line_horizon_gray2.svg) repeat-x center;
    font-size: 2rem;
  }
  &--txt{
    padding: 0 2rem;
    background: white;
  }
}
.container.mt-9{
  margin-top: 0 !important;
}
.list-style04--btn.mt-6{
  @media (max-width: $mobile-size) {
    margin-top: 2rem;
  }
}
</style>
